export enum IPaymentState {
  PAYMENT_NOT_DO_IT = 'PaymentNotDoIt',
  DOING_PAYMENT = 'DoingPayment',
  PAYMENT_SUCCESS = 'PaymentSuccess',
  PAYMENT_FAILED = 'PaymentFailed',
}
